<template v-if="item">
  <div class="card mb-3 min-card-bucket">
    <div class="card-body pb-1">
      <div class="row">
        <div class="col-12 no-wrap">
          <card-options
            :bucketId="item.bucket_id"
            :itemId="item.id"
            :index="index"
            :userAdmin="userAdmin"
            @deleteTask="deleteTask"
            @copyTask="copyTask"
          />
          
          <h5 class="text-color mb-0">
            <template v-if="parseInt(item.status) === 4">
              <i class="bx bxs-check-circle text-success font-size-20"></i>
              <strike class="font-size-15" @click="clickEmit()">
                <h5 class="mb-1 mt-0 font-size-12 text-primary">
                    {{statusTxt}}
                </h5>
                {{ item.name }}
              </strike>
            </template>
            <!-- 4 = concluído, 10 cancelado, 11 stand by -->
            <template v-else>
              <i
                class="bx bx bxs-bolt-circle font-size-20"
                v-if="parseInt(item.status) != 4 && parseInt(item.status) != 10 && parseInt(item.status) != 11"
              
              ></i>
              <i class="bx bx-circle font-size-20" v-else></i>

              <span class="font-size-15" @click="clickEmit()">
                 <h5 class="mb-1 mt-0 font-size-12 text-primary">
                    {{statusTxt}}
                </h5>{{ item.name }}</span>
            </template>
          </h5>
        </div>
        <!--
        <div class="col-12 pb-2 no-wrap">
          <p
            class="font-size-12 text-colo mb-0 mt-1"
            v-if="item.description"
          >{{ item.description | limited(120) }}</p>
        </div>-->
        <div class="col-12 pb-2" v-if="propertiesView && viewProperties.length > 0">
          <template v-for="p in propertiesView">
            <span
              :key="p.propertie_id"
              v-if="p.propertie.propertie_type_id == 6 && viewProperties.indexOf(p.propertie_id) > -1 && p.realValue != null"
              class="font-size-12 fake-propertie mt-1 mr-1"
            >
              <span
                class="badge color-box tag-1"
                :class="'tag-'+p.realValueIndex"
                style="padding:10px"
              >{{p.realValue}}</span>
            </span>
            <span
              :key="p.propertie_id"
              class="font-size-12 my-0 mt-1 mr-1"
              v-if="p.propertie.propertie_type_id != 6 && viewProperties.indexOf(p.propertie_id) > -1"
            >
              <span
                class="badge color-box bg-dark-subtle text-body"
                style="padding:10px"
              >{{p.realValue}}</span>
            </span>
          </template>
        </div>
      </div>
    </div>
    <div class="card-footer my-card-footer">
      <div class="row align-items-center">
        <div class="col-4 align-items-center">
          <i class="bx bx-calendar text-primary font-size-16 me-1"></i>
          <span
            class="font-size-12 text-color"
            v-if="item.date_end"
          >{{ item.date_end | dateString('dd/mm') }}</span>
          
        </div>
        <div class="col-8 text-end" v-if="item.users">
          <app-avatar-admin
            v-for="(userTeam, index2) in item.users"
            v-bind:key="index2"
            :name="userTeam.name"
            class="avatar-mini"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppAvatarAdmin from "@/components/AppAvatarAdmin/AppAvatarAdmin.vue";
import CardOptions from "./CardOptions.vue";

export default {
  name: "AppMiniCard",
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number,
      default: null
    },
    userAdmin:{
      type: Number,
      default: null
    },
    properties: {
      type: [Array, Object],
      default: () => []
    },
    viewProperties: {
      type: Array
    }
  },
  components: {
    AppAvatarAdmin,
    CardOptions
  },
  data() {
    return {
      dropDow: false,
      propertiesView: null,
      statusTxtValues: [{ id: '1', value: 'Em criação ihouse'}, { id: '2', value: 'Em aprovação mkt/negócio'}, { id: '3', value: 'Em backlog'}, { id: '4', value: 'Concluído'},{ id: '5', value: 'Aguardando infos itaú'},{ id: '6', value: 'Aguardando infos squad'},{ id: '7', value: 'Aguardando infos HUB'},{ id: '8', value: 'Planejamento'},{ id: '9', value: 'Pautar'},{ id: '10', value: 'Cancelado'},{ id: '11', value: 'Stand by'},{ id: '12', value: 'Em produção/hub'}],
      statusTxt: null
    };
  },
  watch: {
    viewProperties: {
      handler() {
        this.initializeProperties();
      },
      immediate: true
    }
  },
  created() {
    this.initializeProperties();
  },
  methods: {
    getStatus(st) {
      const status = this.statusTxtValues.find(el => el.id === st.toString());
      return status ? status.value : null;
    },
    //Removido
    updateStatus() {
      let v = 4;
      //4 = concluído, 10 cancelado, 11 stand by
      if (
        this.item.status === 4 ||
        this.item.status === 10 ||
        this.item.status === 11
      ) {
        v = 1;
      }
      //this.$emit("taskUpdateStatus", this.item.bucket_id, this.item.id, v);
    },
    clickEmit() {
      //this.$emit("openForm", this.index, this.item.id);
      this.$emit("openForm", this.item.bucket_id, this.item.id);
    },
    deleteTask(bucket_id, item_id) {
      this.$emit("deleteTask", bucket_id, item_id);
    },
    copyTask(bucket_id, item_id){
      this.$emit("copyTask", bucket_id, item_id);
    },
    initializeProperties() {
      this.statusTxt = this.getStatus(this.item.status);
      if (
        this.properties &&
        this.properties.length > 0 &&
        this.properties[0].properties
      ) {
        let propriedades = this.properties[0].properties;
        let valores = this.item.values;
        this.propertiesView = propriedades.map(propriedade => {
          const valorEncontrado = valores.find(
            valor => valor.propertie_id === propriedade.propertie_id
          );

          if (valorEncontrado) {
            if (propriedade.propertie.propertie_type_id === 6) {
              const valoresList = JSON.parse(propriedade.propertie.values);
              const valorRealIndex = valoresList.findIndex(
                item => item.id === parseInt(valorEncontrado.value, 10)
              );
              const valorReal =
                valorRealIndex !== -1 ? valoresList[valorRealIndex] : null;

              propriedade.realValue = valorReal ? valorReal.name : null;
              propriedade.realValueIndex = valorRealIndex;
            } else {
              propriedade.realValue = valorEncontrado.value;
              propriedade.realValueIndex = null; // Opcional: defina um valor padrão quando não for do tipo 6
            }
          } else {
            propriedade.realValue = null;
            propriedade.realValueIndex = null; // Opcional: defina um valor padrão quando não houver valor encontrado
          }
          return propriedade;
        });
      }
    }
  }
};
</script>

<style scoped>
p,
span {
  text-wrap-mode: auto;
  text-wrap: auto;
}
.dropdown-menu.show {
  position: absolute;
  margin: 0px;
  padding: 0px;
  transform: translate3d(0px, 23px, 0px);
  top: 25px !important;
  right: -20px;
}

.dropdown-item {
  padding: 0.55rem;
}
h5 {
  display: flex;
  justify-content: flex-start;
}
h5 i {
  margin-right: 12px;
}
h5 span {
  cursor: pointer;
}
span > .badge {
  margin: 5px;
}
.no-wrap{
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-all;
}
.min-card-bucket{
  min-height: 130px;
}
</style>